import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { SelectItem } from 'primeng/api';
import { CommonPersonModel } from 'src/app/model/common/person';
import { CommonPersonViewModel } from 'src/app/model/common/person.view';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';

export interface CommonPersonState {
  result: VonPageResponseModel<CommonPersonViewModel>;
  data: CommonPersonModel;
  locationBorn: SelectItem<KhuyanaSelectItemModel>;
}

export const commonPersonIS: CommonPersonState = {
  result: {
    content: [],
    last: false,
    totalPages: 0,
    totalElements: 0,
    size: 0,
    numberOfElements: 0,
    number: 0,
  },
  data: {
    emailHelp: [{ value: '' }],
    phoneHelp: [{ value: '' }],
  },
  locationBorn: { value: {} },
};
